import { Offcanvas } from "bootstrap";
import { v4 as uuidv4 } from 'uuid';
import { createApp } from "vue";
import draggable from 'vuedraggable';
import { B2bToast, DmkVideoManager, bootbox } from "../B2bTools";
import Store from "../Store";
import { dropzonePage } from './composant/dropzonePage';

import html from "./pagebuilder.html";

const confDisposition = {
	'd1': [12],
	'd66': [6, 6],
	'd444': [4, 4, 4],
}

const confLayout = () => {
	return {
		id: uuidv4(),
		title: "My title",
		description: "",
		link: { type: "page", page: "", linelist: "" },
		media: { type: "img", url: "" }
	}
}

const js = ({
	url: function (echangeur) {
		 let u = Store.get('getURUL')()
		if(!echangeur.hash.u) echangeur.hash.env= u;

		echangeur.addAction('b2b.page.edit', echangeur.hash, '', 'form');
		//echangeur.addAction('b2b.page.list', echangeur.hash, '', 'list');
	},
	onLoad: function (echangeur) {
		let THIS = this;
		const videoManager = new DmkVideoManager();

		// !!! @TODO visualisation des page et du fil d'ariane
		// const buildLinks = async () => {
		// 	const pages = echangeur.form.pages
		// 	const linelists = echangeur.form.linelists
		// 	let links = []
		// 	// 64491e2f2e2ea2590892c222
		// 	// 6509c52226c5560948071b2d
		// 	// let result = await THIS.rest("b2b.page.edit", '6509c52226c5560948071b2d', { "page_id": '6509c52226c5560948071b2d' });
		// 	// console.log(result)
		// 	/* 			for (let page of pages) {
		// 					// console.log(page._id)
		// 					let result = await THIS.rest("b2b.page.edit", { "page_id": page._id });
		// 					// console.log(result)
		// 					links.push(result)
		// 				}
		// 				console.log(links) */
		// 	// this.links = result
		// 	// links: buildLinks(echangeur.form.pages, echangeur.form.linelists),
		// }
		// buildLinks()

		const app = createApp({
			data: function () {
				return {
					title: echangeur.form.title,
					id: echangeur.form.doc._id,
					sections: echangeur.form.doc.sections,

					v: echangeur.form.doc.v,
					doc: echangeur.form.doc,
					arianes: echangeur.form.arianes,
					pages: echangeur.form.pages,
					env:	echangeur.form.doc.env,

					linelists: echangeur.form.linelists,

					links: null,
					saisie: {},
					deleteLayoutConfirm: false,
					bsOffcanvas: null,

					isAllPages: false
				}
			},

			components: {
				draggable,
				dropzonePage
			},

			methods: {

				gotoAriane(ariane) {
					const p = { page: ariane._id };
					THIS.hashChaine("pagebuilder", p);
				},

				pageSelected(page) {
					return (page._id == this.id) ? 'bg-light' : 'bg-white'
				},

				gotoPage(page) {
					const p = { page: page._id };
					if (this.modeEdit) p.modeEdit = this.modeEdit;
					THIS.hashChaine("pagebuilder", p);
				},

				async addPage() {
					const result = await THIS.rest("b2b.page.create", { "_id": this.id, "env": this.env });
					if (result.ok) {
						echangeur.hash.t = new Date().toISOString();
						THIS.hashChaine("pagebuilder", echangeur.hash);
					}
				},

				async savePage(page) {
					const form = {
						_id: page._id,
						v: page.v,
						env: page.env
					}
					const result = await THIS.rest("b2b.page.save", {env: this.env}, form);
					if (result.ok) {
						this.pages = result.pages;
						echangeur.hash.t = new Date().toISOString();
						THIS.hashChaine("pagebuilder", echangeur.hash);
						B2bToast(`Page name has been modified to <b>${page.v}</b>`, 'success')
					}
				},

				deletePage(page) {
					bootbox.confirm(
						{
							title: 'Remove page',
							message: `Are you sure to remove <b> ${page.v} </b> ?`
						},
						async function () {
							const result = await THIS.rest("b2b.page.del", { "_id": page._id });
							if (result.ok) {
								if (page._id == this.id) delete echangeur.hash.page;
								echangeur.hash.t = new Date().toISOString();
								THIS.hashChaine("pagebuilder", echangeur.hash);
							}
						}
					)
				},

				reset() {
					this.bsOffcanvas.hide();
					this.deleteLayoutConfirm = false
					this.saisie = {}
				},

				activeSection() {
					return this.sections.findIndex(x => x.id === this.saisie.id)
				},

				changePosition(indexDestination) {
					const sections = this.sections
					const indexSource = sections.findIndex(x => x.id === this.saisie.id)
					sections.splice(indexDestination, 0, sections.splice(indexSource, 1)[0]);
				},

				toCol(col = confDisposition[0]) {
					return confDisposition[col].map(x => 'col-xl-' + x)[0]
				},

				setImgReg1(tempname, type, index) {
					this.saisie.rows[index].media = {
						type: type,
						url: tempname
					}
				},

				toUrl(media) {
					return (media) ? `attachment/page/${this.id}_${media}` : 'assets/img/placeholder.jpg'
				},

				addVideo(el) {
					videoManager.add(el);
				},

				isDisabledDeleteAll() {
					if (this.saisie.rows) {
						return (this.saisie.rows.length === Object.keys(confDisposition).length)
					}
				},

				isDisabledDelete() {
					return (this.saisie.rows.length === 1)
				},

				addElement() {
					const dispo = Object.keys(confDisposition)
					const index = dispo.findIndex(a => a === this.saisie.disposition)

					if (dispo.length > index + 1) {
						this.saisie.disposition = dispo[index + 1]
						this.saisie.rows.push(confLayout())
					}
				},

				deleteElement(id) {
					const dispo = Object.keys(confDisposition)
					const index = dispo.findIndex(a => a === this.saisie.disposition)

					const indexId = this.saisie.rows.findIndex(a => a.id === id)

					if (index > 0) {
						this.saisie.disposition = dispo[index - 1]
						this.saisie.rows.splice(indexId, 1);
					}
				},

				editLayout(id) {
					const saisie = this.sections.find(x => x.id === id)
					const copySaisie = JSON.parse(JSON.stringify(saisie));
					this.saisie = copySaisie
				},

				async saveLayout() {
					const copySection = [...this.sections]
					const index = copySection.findIndex(section => section.id === this.saisie.id);

					if (index !== -1) {
						copySection[index] = this.saisie;

						for (const row of this.saisie.rows) {
							const form = {
								_id: this.id,
								sections: copySection,
								$batchImg: { reg1: row.media.url }
							}
							const result = await THIS.rest("b2b.page.save", {env: this.env}, form);
							if (result.ok) this.sections = result.doc.sections;
							this.reset()
						}
					}
				},

				async addLayout({ disposition = 'd1' }) {
					this.saisie = {}
					const form = {
						_id: this.id,
						sections: this.sections.map(u => u),
					}
					const section = {
						disposition,
						id: uuidv4(),
						rows: confDisposition[disposition].map(() => (confLayout()))
					}
					form.sections.push(section);

					const result = await THIS.rest("b2b.page.save",  {env: this.env}, form);
					if (result.ok) this.sections = result.doc.sections;
				},

				async deleteLayout() {
					const form = {
						_id: this.id,
						sections: this.sections.map(u => u),
					}

					const index = this.sections.findIndex(item => item.id === this.saisie.id);
					if (index !== -1) {
						form.sections.splice(index, 1);

						const result = await THIS.rest("b2b.page.save",  {env: this.env}, form);
						if (result.ok) this.sections = result.doc.sections;
						this.reset()
					}
				},
			},

			mounted() {
				videoManager.whenMounted();

				this.bsOffcanvas = new Offcanvas(
					document.getElementById("offcanvasPagebuilderEdit"), { toggle: false }
				);
				this.reset()
			}

		});

		app.mount(THIS.c$('._vueChargement')[0]);

	},
});

export default {
	pagebuilder: { js, html }
};
